import "./SaaSSeo.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Specialties from "./sections/Specialties";
import SpecialisedServices from "./sections/SpecialisedServices";
import Footer from "@/reusable_sections/Footer";
export default function SaaSSeoPage() {
  return <div>
      <Header />
      <Hero />
      <Specialties />
      <SpecialisedServices />
      <Footer />
    </div>;
}